export default __webpack_public_path__ + "static/media/loading-stamp-4.7079f80f.jpg";